module.exports = __webpack_public_path__ + "client/img/contact_bg_02.308f8ffa.png";